.headerContainer {
    width: 100%;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
} 